import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/sourcetree': {
    width: 406,
    height: 512,
    paths: [
      {
        d: 'M406.2 203C406.2 90.9 315.3 0 203.2 0 91.1-0.2 0.2 90.6 0 202.6-0.1 290.8 56.6 368.9 140.5 396V497.7C140.5 505.6 146.9 512 154.8 512H251.2C259.1 512 265.5 505.6 265.5 497.7V396.1C349.2 369.1 406.1 291.1 406.2 203zM134.6 203C134.6 112.2 271.9 112.2 271.9 203 271.8 292.9 134.6 294 134.6 203z'
      }
    ]
  }
})
